// extracted by mini-css-extract-plugin
module.exports = {"caution":"styles_caution__3ZCML","genreTagLabel":"styles_genreTagLabel__2jeeI","toggle":"styles_toggle__34oyc"};